import {jwtDecode} from "jwt-decode";

//TODO Сделать его
export const getToken = () => {
    return localStorage.getItem('accessToken') === "undefined" ? null: localStorage.getItem('accessToken');
}

export const setTokens = (accessToken) => {
    localStorage.setItem('accessToken', accessToken);

}

export const clearTokens = () => {
    localStorage.removeItem('accessToken');
}

export const decodeToken = (accessToken) => {
    try {
        return jwtDecode(accessToken);
    } catch (err) {
        console.error("Ошибка при декодировании JWT:", err);
        return null;
    }
}